import type { Epic } from 'Flux/index.js'
import { projectSlice } from 'Flux/Slice/Project/ProjectSlice.js'
import { catchError, filter, mergeMap, of, withLatestFrom } from 'rxjs'

export const DeleteProjectSamplesEpic: Epic = (action$, state$, { [projectSlice.name]: project, ProjectRepository }) =>
  action$.pipe(
    filter(project.deleteProjectSamplesRequest.match),
    withLatestFrom(state$),
    mergeMap(([action]) => {
      return ProjectRepository.removeProjectSample(action.payload.projectId, action.payload.projectSampleId).pipe(
        mergeMap(() =>
          of(
            project.deleteProjectSamplesRequestSuccess(action.payload),
            project.loadProjectOrdersRequest({ projectId: action.payload.projectId })
          )
        ),
        catchError((error) => of(project.deleteProjectSamplesRequestFailure({ error })))
      )
    })
  )
